import {ChangeDetectorRef, Component, EventEmitter, Injector, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';

import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';

import {DictService} from '../core/ecv-http-services/services/dict.service';
import {CreateDictionaryModel} from '../dictionary/create-dict.model';
import {DictModel} from '../dictionary/dict.model';
import {CompetenceTypeEnum} from '../enums/competence-type.enum';
import {CustomValidators} from '../core/validator/custom-validators';
import {ValidatorService} from '../core/validator/validator.service';
import {AlertService} from '../widgets/alert/alert.service';
import {DialogService} from './dialog.service';
import {DictType} from '../enums/dict-types.enum';
import {DictEnum} from '../enums/dict.enum';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html'
})
export class DialogComponent implements OnInit, OnDestroy {

  DictEnum = DictEnum;
  maxLength: number;
  title: string;
  addDictForm: FormGroup;
  dictModel: CreateDictionaryModel = new CreateDictionaryModel();
  control: FormControl;
  dict: DictModel[] = [];
  @Output() changeDict: EventEmitter<DictModel> = new EventEmitter<DictModel>();
  DictType = DictType;
  closeEmitter: EventEmitter<any>;

  competenceTypeDict: DictModel[] = [];
  dialogService: DialogService;
  visible = true;

  constructor(public activeModal: NgbActiveModal,
              private dictService: DictService,
              private translateService: TranslateService,
              private alertService: AlertService,
              public changeRef: ChangeDetectorRef,
              private validatorService: ValidatorService,
              private injector: Injector) {
    this.maxLength = 100;
    this.loadCompetenceTypeDict();
    setTimeout(() => this.dialogService = injector.get(DialogService));
  }

  ngOnInit() {
    this.createForm();
  }

  ngOnDestroy(): void {
    this.emitClose();
  }

  private createForm() {
    this.addDictForm = new FormGroup({
      'description': new FormControl('', CustomValidators.notEmpty),
      'descriptionEng': new FormControl('', CustomValidators.notEmpty)
    });
    switch (this.dictModel.dictType) {
      case DictType.COMPETENCE: {
        this.addDictForm.addControl('competenceType', new FormControl('', CustomValidators.notEmpty));
        break;
      }
      case this.DictType.EMPLOYER: {
        this.addDictForm.addControl('companyBlind', new FormControl(''));
        this.addDictForm.addControl('companyBlind-id', new FormControl('', CustomValidators.validateCorrectDict));
        this.addDictForm.addControl('economySector', new FormControl(''));
        this.addDictForm.addControl('economySector-id', new FormControl('', CustomValidators.validateCorrectDict));
        break;
      }
    }
  }

  close() {
    this.activeModal.close(false);
    this.emitClose();
  }

  save() {
    this.validatorService.validate(this.addDictForm);
    if (!this.validatorService.isValid(this.addDictForm)) {
      return;
    }
    this.dictModel.description = this.addDictForm.get('description').value;
    this.dictService.createDict(this.dictModel).subscribe(response => {
      this.dict.push(<DictModel>response);
      this.changeDict.emit(<DictModel>response);
      this.translateService.get('ALERT.DICT_SAVED', {}).subscribe((res: string) => {
        this.alertService.success(res);
        this.control.patchValue(this.addDictForm.get('description').value);
        this.activeModal.close(response);
        this.emitClose();
      });
    });
  }

  dismiss(s: string) {
    this.activeModal.dismiss(s);
    this.emitClose();
  }

  loadCompetenceTypeDict() {
    for (const competenceType in CompetenceTypeEnum) {
      if (typeof CompetenceTypeEnum[competenceType] === 'number') {
        this.translateService.get('DICTIONARIES.COMPETENCE_TYPES.' + competenceType).subscribe(res => {
          this.competenceTypeDict.push({
            id: +CompetenceTypeEnum[competenceType],
            description: res,
            descriptionEng: res
          });
        });
      }
    }
  }

  openEmployerBlindDialog() {
    this.visible = false;
    const eventEmitter = new EventEmitter();
    this.dialogService.open('MODAL_HEADER.ADD_EMPLOYER_BLIND', DictType.EMPLOYER_BLIND,
      this.addDictForm.get('companyBlind'), 200,
      this.dictModel, 'employerBlindDictId', eventEmitter);
    eventEmitter.subscribe(() => this.visible = true);
  }

  openEconomySectorDialog() {
    this.visible = false;
    const eventEmitter = new EventEmitter();
    this.dialogService.open('MODAL_HEADER.ADD_ECONOMY_SECTOR', DictType.ECONOMY_SECTOR,
      this.addDictForm.get('economySector'), 50,
      this.dictModel, 'economySectorDictId', eventEmitter);
    eventEmitter.subscribe(() => this.visible = true);
  }

  emitClose() {
    this.visible = true;
    if (this.closeEmitter) {
      this.closeEmitter.emit();
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/dialog/dialog.component.ts